import { Injectable } from "@angular/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from "@angular/router";
import { Observable } from "rxjs";
import { ActivatedRoute, Router } from "@angular/router";
import Swal from 'sweetalert2';
import { AuthService } from "./auth.service";

@Injectable({
  providedIn: "root",
})
export class BuyerAuthGuard implements CanActivate {
  constructor(private auth: AuthService, private router: Router) {}

  async canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ){
    let permissions = await this.auth.getPermissions();
    let hasPermission = permissions.some((item: { clientURL: string; [key:string]: any }) => {
      return item.clientURL == "/pay";
    });

    if (hasPermission){ 
      return true;
    }
    else {
      Swal.fire({
        icon: 'warning',
        title: 'Access Denied',
        text: 'You do not have permission ',
      })
  
      this.router.navigate(["/"]);
      return false
    }
  }
}
